export default __webpack_public_path__ + "cfbf0da06d33097e6d0afbb9e49fc5bc.ttf";